(() => {
  const body = document.body;
  const header = document.querySelector('[data-lux-header]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileOverlay = document.querySelector('[data-mobile-menu-overlay]');
  const mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer-overlay');
  const pathParts = window.location.pathname.split('/').filter(Boolean);
  const firstPathPart = pathParts[0] || '';
  const supportedLocales = new Set(['en', 'es']);
  const localeSegment = supportedLocales.has(firstPathPart) ? firstPathPart : '';
  const currentLocale = (document.documentElement.lang || localeSegment || 'es').toLowerCase().split('-')[0];
  const isEnglish = currentLocale === 'en' || localeSegment === 'en';
  const strings = isEnglish ? {
    emptyCart: 'Your cart is empty',
    viewCookies: 'View cookies',
    quantity: 'Quantity',
    remove: 'Remove',
    adding: 'Adding',
    added: 'Added',
  } : {
    emptyCart: 'Tu carrito esta vacio',
    viewCookies: 'Ver galletas',
    quantity: 'Cantidad',
    remove: 'Eliminar',
    adding: 'Agregando',
    added: 'Agregado',
  };

  function autoRedirectLanguage() {
    if (window.Shopify && window.Shopify.designMode) return;
    if (window.location.search.includes('preview_theme_id')) return;
    const savedChoice = window.localStorage.getItem('crom_language_choice');
    const browserLanguage = ((navigator.languages && navigator.languages[0]) || navigator.language || 'en').toLowerCase();
    const browserLocale = browserLanguage.split('-')[0];
    const preferred = supportedLocales.has(savedChoice) ? savedChoice : (browserLocale === 'es' ? 'es' : 'en');

    if (preferred === currentLocale) return;

    const localizedPathParts = localeSegment ? pathParts.slice(1) : pathParts;
    const targetPathParts = preferred === 'en' ? ['en', ...localizedPathParts] : localizedPathParts;
    const targetPath = `/${targetPathParts.join('/')}`.replace(/\/$/, '') || '/';
    const targetUrl = `${targetPath}${window.location.search}${window.location.hash}`;
    if (targetUrl !== `${window.location.pathname}${window.location.search}${window.location.hash}`) {
      window.location.replace(targetUrl);
    }
  }

  try {
    autoRedirectLanguage();
  } catch {
    // Localization should never block shopping if browser storage is unavailable.
  }

  function setSavedLanguage(language) {
    try {
      window.localStorage.setItem('crom_language_choice', language);
    } catch {}
  }

  function buildLocalizedPath(language) {
    const parts = window.location.pathname.split('/').filter(Boolean);
    const first = parts[0] || '';
    const hasLocale = supportedLocales.has(first);
    const bareParts = hasLocale ? parts.slice(1) : parts;
    const targetParts = language === 'en' ? ['en', ...bareParts] : bareParts;
    return `/${targetParts.join('/')}`.replace(/\/$/, '') || '/';
  }

  function changeLanguage(language) {
    setSavedLanguage(language);
    const search = new URLSearchParams(window.location.search);
    search.delete('view');
    const query = search.toString();
    const target = `${buildLocalizedPath(language)}${query ? `?${query}` : ''}${window.location.hash}`;
    window.location.href = target;
  }

  function createLanguageSwitcher(placement) {
    const wrapper = document.createElement('div');
    wrapper.className = `lux-language-switcher lux-language-switcher--${placement}`;
    wrapper.innerHTML = `
      <div class="lux-language-switcher__form" role="group" aria-label="${isEnglish ? 'Choose language' : 'Elegir idioma'}">
        <span class="lux-language-switcher__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false">
            <circle cx="12" cy="12" r="9"></circle>
            <path d="M3.6 9h16.8M3.6 15h16.8M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"></path>
          </svg>
        </span>
        <button type="button" class="lux-language-switcher__option${isEnglish ? '' : ' is-active'}" aria-label="Espanol" aria-pressed="${isEnglish ? 'false' : 'true'}" data-fallback-lang="es">ES</button>
        <button type="button" class="lux-language-switcher__option${isEnglish ? ' is-active' : ''}" aria-label="English" aria-pressed="${isEnglish ? 'true' : 'false'}" data-fallback-lang="en">EN</button>
      </div>
    `;
    wrapper.querySelectorAll('[data-fallback-lang]').forEach((button) => {
      button.addEventListener('click', () => changeLanguage(button.dataset.fallbackLang));
    });
    return wrapper;
  }

  function injectLanguageSwitchers() {
    if (!document.querySelector('.lux-language-switcher--header')) {
      const actions = document.querySelector('.lux-header__actions');
      const cart = actions?.querySelector('.lux-header__cart');
      if (actions) actions.insertBefore(createLanguageSwitcher('header'), cart || actions.firstChild);
    }

    if (!document.querySelector('.lux-language-switcher--drawer')) {
      const drawer = document.querySelector('.lux-mobile-drawer');
      if (drawer) drawer.appendChild(createLanguageSwitcher('drawer'));
    }

    if (!document.querySelector('.lux-language-switcher--footer')) {
      const footerBrand = document.querySelector('.lux-footer__brand');
      const social = footerBrand?.querySelector('.lux-footer__social');
      if (footerBrand) footerBrand.insertBefore(createLanguageSwitcher('footer'), social ? social.nextSibling : null);
    }
  }

  function localizeInternalLinks() {
    document.querySelectorAll('a[href^="/"]').forEach((link) => {
      const url = new URL(link.getAttribute('href'), window.location.origin);
      const parts = url.pathname.split('/').filter(Boolean);
      const hasLocale = supportedLocales.has(parts[0]);
      if (isEnglish && !hasLocale) {
        url.pathname = `/${['en', ...parts].join('/')}`.replace(/\/$/, '') || '/en';
      } else if (!isEnglish && hasLocale) {
        url.pathname = `/${parts.slice(1).join('/')}`.replace(/\/$/, '') || '/';
      } else {
        return;
      }
      link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
    });
  }

  function translateCachedEnglishHome() {
    if (!isEnglish) return;
    const normalizedPath = window.location.pathname.replace(/^\/en\/?/, '/') || '/';
    if (normalizedPath !== '/' || !document.body.classList.contains('template-index')) return;

    const exactText = new Map([
      ['Saltar al contenido', 'Skip to content'],
      ['Galletas', 'Cookies'],
      ['Coleccion Dubai', 'Dubai Collection'],
      ['Nuestra Historia', 'Our Story'],
      ['Contacto', 'Contact'],
      ['Carrito', 'Cart'],
      ['Lo artesanal elevado a lujo', 'Handcrafted, elevated to luxury'],
      ['Creamos galletas premium donde cada textura, cada sabor y cada acabado hablan de pasion, intencion y excelencia.', 'We create premium cookies where every texture, flavor, and finish speaks of passion, intention, and excellence.'],
      ['Comprar Galletas', 'Shop Cookies'],
      ['Descubrir Dubai', 'Discover Dubai'],
      ['No horneamos en masa', 'We do not bake in mass'],
      ['Pasion, intencion y excelencia', 'Passion, intention, and excellence'],
      ['Textura, sabor y acabado', 'Texture, flavor, and finish'],
      ['Ingredientes premium', 'Premium ingredients'],
      ['Cada receta cuenta una historia', 'Every recipe tells a story'],
      ['Galletas para celebrar lo especial', 'Cookies made to celebrate the special'],
      ['No horneamos en masa. Cuidamos cada textura, cada sabor y cada acabado para que cada mordida se sienta como un momento dorado.', 'We do not bake in mass. We care for every texture, flavor, and finish so each bite feels like a golden moment.'],
      ['Agregar', 'Add'],
      ['Agotado', 'Sold out'],
      ['Ver todas las galletas', 'View all cookies'],
      ['El lujo de Dubai en cada mordisco', 'Dubai luxury in every bite'],
      ['Una coleccion creada desde el equilibrio entre tecnica y emocion: pistacho, avellana caramelizada y chocolate en una textura intensa, sofisticada y memorable.', 'A collection created from the balance between technique and emotion: pistachio, caramelized hazelnut, and chocolate in an intense, sophisticated, memorable texture.'],
      ['Explorar Coleccion Dubai', 'Explore Dubai Collection'],
      ['Tecnica, emocion y excelencia', 'Technique, emotion, and excellence'],
      ['Técnica, emoción y excelencia', 'Technique, emotion, and excellence'],
      ['El deseo de ir mas alla', 'The desire to go beyond'],
      ['CRÖM nace del deseo de elevar lo artesanal a una experiencia de lujo. Cada pieza se trabaja con intencion: entre lo clasico y lo sofisticado, entre el arte de hornear y el placer de disfrutar.', 'CRÖM was born from the desire to elevate the handmade into a luxury experience. Each piece is crafted with intention: between classic and sophisticated, between the art of baking and the pleasure of enjoying.'],
      ['Conoce nuestra historia', 'Read our story'],
      ['Cada empaque guarda un momento', 'Every package holds a moment'],
      ['Detalles creados para permanecer', 'Details created to linger'],
      ['Regalos, eventos y mesas dulces pensados para acompanar celebraciones con presencia, cuidado y una sensacion de lujo cercano.', 'Gifts, events, and dessert tables designed to accompany celebrations with presence, care, and a feeling of warm luxury.'],
      ['Regalos Corporativos', 'Corporate Gifts'],
      ['Cada empaque guarda un momento: una entrega cuidada, elegante y lista para permanecer.', 'Every package holds a moment: a thoughtful, elegant delivery designed to be remembered.'],
      ['Eventos & Fiestas', 'Events & Parties'],
      ['Galletas premium para acompanar celebraciones donde cada mordida celebra lo especial.', 'Premium cookies for celebrations where every bite honors the special.'],
      ['Una propuesta dulce, calida y elegante, creada con tecnica y emocion para compartir.', 'A sweet, warm, elegant proposal crafted with technique and emotion to share.'],
      ['Consultar opciones', 'Ask about options'],
      ['Aqui no horneamos en masa. Creamos grandes suenos en forma de galleta: textura, sabor y acabado cuidados uno a uno.', 'We do not bake in mass. We create big dreams in cookie form: texture, flavor, and finish cared for one by one.'],
      ['Recibe el proximo momento dorado', 'Receive the next golden moment'],
      ['Suscribete para conocer nuevas recetas, lanzamientos especiales y detalles pensados para quienes disfrutan lo extraordinario con calma.', 'Subscribe for new recipes, special launches, and details created for those who enjoy the extraordinary with calm.'],
      ['Suscribirme', 'Subscribe'],
      ['Tienda', 'Shop'],
      ['Todas las galletas', 'All cookies'],
      ['Mas vendidas', 'Best sellers'],
      ['Información', 'Information'],
      ['Informacion', 'Information'],
      ['Privacidad', 'Privacy'],
      ['Envios y pedidos', 'Shipping and orders'],
      ['CRÖM eleva lo artesanal a una experiencia de lujo: tecnica, emocion y momentos dorados en cada mordida.', 'CRÖM elevates the handmade into a luxury experience: technique, emotion, and golden moments in every bite.'],
      ['Pagos procesados de forma segura por Shopify.', 'Payments are securely processed by Shopify.'],
      ['Tu seleccion', 'Your selection'],
      ['Continuar al pago', 'Continue to checkout'],
      ['Ver seleccion completa', 'View full selection'],
      ['Ver galletas', 'View cookies'],
    ]);

    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || ['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA'].includes(parent.tagName)) {
          return NodeFilter.FILTER_REJECT;
        }
        return node.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      },
    });

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const raw = node.nodeValue;
      const trimmed = raw.trim();
      const translated = exactText.get(trimmed);
      if (!translated) return;
      const prefix = raw.match(/^\s*/)[0];
      const suffix = raw.match(/\s*$/)[0];
      node.nodeValue = `${prefix}${translated}${suffix}`;
    });

    document.title = 'CRÖM Cookies & Cakes | Premium Artisan Cookies in Georgia';
    document.querySelectorAll('[aria-label="Ver carrito"]').forEach((node) => node.setAttribute('aria-label', 'View cart'));
    document.querySelectorAll('[aria-label="Abrir menu"]').forEach((node) => node.setAttribute('aria-label', 'Open menu'));
    document.querySelectorAll('[aria-label="Navegacion principal"]').forEach((node) => node.setAttribute('aria-label', 'Main navigation'));
    document.querySelectorAll('[aria-label="Navegacion movil"]').forEach((node) => node.setAttribute('aria-label', 'Mobile navigation'));
  }

  function hydrateCachedLocalizationFallback() {
    injectLanguageSwitchers();
    localizeInternalLinks();
    translateCachedEnglishHome();
  }

  hydrateCachedLocalizationFallback();

  document.querySelectorAll('[data-lang-option]').forEach((button) => {
    button.addEventListener('click', () => {
      setSavedLanguage(button.dataset.langOption.split('-')[0]);
    });
  });

  function setCartCount(count) {
    document.querySelectorAll('.lux-cart-count, .cart-count, .header__cart-count').forEach((node) => {
      node.textContent = String(count);
    });
  }

  function openMobileMenu() {
    if (!mobileMenu || !mobileToggle || !mobileOverlay) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    mobileMenu.removeAttribute('inert');
    mobileToggle.setAttribute('aria-expanded', 'true');
    mobileOverlay.hidden = false;
    body.classList.add('drawer-open');
  }

  function closeMobileMenu() {
    if (!mobileMenu || !mobileToggle || !mobileOverlay) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    mobileMenu.setAttribute('inert', '');
    mobileToggle.setAttribute('aria-expanded', 'false');
    mobileOverlay.hidden = true;
    body.classList.remove('drawer-open');
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('active');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartDrawer.removeAttribute('inert');
    if (cartOverlay) cartOverlay.classList.add('active');
    body.classList.add('drawer-open');
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('active');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartDrawer.setAttribute('inert', '');
    if (cartOverlay) cartOverlay.classList.remove('active');
    body.classList.remove('drawer-open');
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return `$${(cents / 100).toFixed(2)}`;
  }

  function renderCartDrawer(cart) {
    const bodyNode = document.getElementById('cartDrawerBody');
    if (!bodyNode) return;
    const footerNode = document.querySelector('.cart-drawer__footer');

    if (!cart.items.length) {
      bodyNode.innerHTML = `
        <div class="cart-drawer__empty">
          <p class="cart-drawer__empty-text">${strings.emptyCart}</p>
          <a href="${window.luxRoutes?.allProducts || '/collections/all'}" class="lux-btn">${strings.viewCookies}</a>
        </div>
      `;
      if (footerNode) footerNode.hidden = true;
      return;
    }
    if (footerNode) footerNode.hidden = false;

    bodyNode.innerHTML = cart.items.map((item) => `
      <div class="cart-drawer-item" data-key="${item.key}">
        <div class="cart-drawer-item__image">
          ${item.image ? `<img src="${item.image}" alt="${item.product_title}" width="80" height="80" loading="lazy">` : ''}
        </div>
        <div class="cart-drawer-item__info">
          <h4 class="cart-drawer-item__title">${item.product_title}</h4>
          ${item.variant_title ? `<p class="cart-drawer-item__variant">${item.variant_title}</p>` : ''}
          <p class="cart-drawer-item__price">${formatMoney(item.final_price)}</p>
          <p class="cart-drawer-item__quantity">${strings.quantity}: ${item.quantity}</p>
        </div>
        <button type="button" class="cart-drawer-item__remove" data-cart-remove="${item.key}" aria-label="${strings.remove} ${item.product_title}">x</button>
      </div>
    `).join('');

    const totalNode = document.querySelector('.cart-drawer__total-price');
    if (totalNode) totalNode.textContent = formatMoney(cart.total_price);
  }

  async function getCart() {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return response.json();
  }

  async function changeCartItem(key, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    return response.json();
  }

  if (header) {
    const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 18);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  if (mobileToggle) {
    mobileToggle.addEventListener('click', () => {
      const isOpen = mobileToggle.getAttribute('aria-expanded') === 'true';
      if (isOpen) closeMobileMenu();
      else openMobileMenu();
    });
  }

  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  document.querySelectorAll('[data-mobile-menu] a').forEach((link) => {
    link.addEventListener('click', closeMobileMenu);
  });

  document.querySelectorAll('[data-cart-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      if (!cartDrawer) return;
      event.preventDefault();
      openCartDrawer();
    });
  });

  document.querySelectorAll('.cart-drawer__close').forEach((button) => {
    button.addEventListener('click', closeCartDrawer);
  });

  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeMobileMenu();
      closeCartDrawer();
    }
  });

  document.addEventListener('click', async (event) => {
    const removeButton = event.target.closest('[data-cart-remove]');
    if (!removeButton) return;
    const cart = await changeCartItem(removeButton.dataset.cartRemove, 0);
    setCartCount(cart.item_count);
    renderCartDrawer(cart);
  });

  document.querySelectorAll('.lux-product-thumb').forEach((button) => {
    button.addEventListener('click', () => {
      const image = document.querySelector('[id^="ProductMainImage-"]');
      if (image && button.dataset.productThumb) image.src = button.dataset.productThumb;
    });
  });

  document.querySelectorAll('.cart-item__qty-btn').forEach((button) => {
    button.addEventListener('click', () => {
      const input = document.querySelector(`.cart-item__qty-input[data-line="${button.dataset.line}"]`);
      if (!input) return;
      const delta = button.dataset.action === 'increase' ? 1 : -1;
      input.value = Math.max(0, Number(input.value || 0) + delta);
    });
  });

  document.querySelectorAll('.cart-item__remove').forEach((button) => {
    button.addEventListener('click', () => {
      const input = document.querySelector(`.cart-item__qty-input[data-line="${button.dataset.line}"]`);
      const form = document.getElementById('cart-form');
      if (!input || !form) return;
      input.value = 0;
      form.submit();
    });
  });

  document.querySelectorAll('form[action="/cart/add"], form[action="/cart/add.js"], .lux-product-form, .lux-product-card__form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      const original = submit ? submit.textContent : '';
      if (submit) {
        submit.disabled = true;
        submit.textContent = strings.adding;
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error('Cart add failed');
        const cart = await getCart();
        setCartCount(cart.item_count);
        renderCartDrawer(cart);
        openCartDrawer();
        if (submit) submit.textContent = strings.added;
      } catch (error) {
        form.submit();
      } finally {
        window.setTimeout(() => {
          if (submit) {
            submit.disabled = false;
            submit.textContent = original;
          }
        }, 1200);
      }
    });
  });

  document.querySelectorAll('[data-qty-control]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = document.querySelector(button.dataset.qtyTarget);
      if (!input) return;
      const delta = button.dataset.qtyControl === 'increase' ? 1 : -1;
      input.value = Math.max(1, Number(input.value || 1) + delta);
    });
  });

  document.querySelectorAll('.lux-product-form').forEach((form) => {
    const jsonNode = form.querySelector('[data-product-json]');
    const idInput = form.querySelector('[name="id"]');
    if (!jsonNode || !idInput) return;

    let product;
    try {
      product = JSON.parse(jsonNode.textContent);
    } catch {
      return;
    }

    const updateVariant = () => {
      const selected = product.options.map((optionName, index) => {
        const checked = form.querySelector(`[name="option-${index + 1}"]:checked`);
        return checked ? checked.value : null;
      });
      const variant = product.variants.find((item) =>
        selected.every((value, index) => !value || item.options[index] === value),
      );
      if (!variant) return;
      idInput.value = variant.id;
      const priceNode = document.querySelector('[data-product-price]');
      if (priceNode) priceNode.textContent = formatMoney(variant.price);
      const submit = form.querySelector('[type="submit"]');
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? submit.dataset.availableText : submit.dataset.soldText;
      }
    };

    form.querySelectorAll('[name^="option-"]').forEach((input) => {
      input.addEventListener('change', updateVariant);
    });
    updateVariant();
  });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14 });

    document.querySelectorAll('.reveal-on-scroll').forEach((node) => observer.observe(node));
  } else {
    document.querySelectorAll('.reveal-on-scroll').forEach((node) => node.classList.add('is-visible'));
  }
})();
